// appName should be in hyphenated format (app-name)
export function loadDocumentBuilderPolyfills(appName: string): void {
  /** Necessary to set these env variables so styled-components don't fail */
  let w: any;
  if (typeof globalThis !== 'undefined') {
    w = globalThis;
  } else if (typeof window !== 'undefined') {
    w = window;
  }
  w.process = w.process || {};
  w.process.env = w.process.env || {};
  w.process.env.REACT_APP_SC_ATTR = w.process.env.REACT_APP_SC_ATTR || `data-styled-${appName}`;
  w.process.env.SC_ATTR = w.process.env.SC_ATTR || `data-styled-${appName}`;
}
